import type {Catalog} from './catalog';
import type {ChooseGroup} from './types';

/** варианты выбора у предмета: основа из каталога по фильтрам или перечисленные варианты */
export const itemChoiceOptions = (group: ChooseGroup, catalog: Catalog) => {
	if (group.type !== 'item')
		return (group.options || []).map((option) => ({value: option.key, label: option.label || option.key}));
	const {itemType = [], armorKind = []} = group.filters;
	return catalog.items
		.filter((item) => !itemType.length || itemType.includes(item.type || ''))
		.filter((item) => !armorKind.length || armorKind.some((kind) => item.subTypes.includes(kind)))
		.map((item) => ({value: item.id, label: item.title}));
};
